import { useEffect } from 'react';

const useClickOutside = (ref, callback, callback1) => {
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        callback();
      } else {
        if (callback1) {
          callback1();
        }
      }
    };

    document.addEventListener('pointerdown', handleClickOutside, true);

    return () => {
      document.removeEventListener('pointerdown', handleClickOutside, true);
    };
  }, [ref, callback, callback1]);
};

export default useClickOutside;
